  import React, { useEffect, useState } from "react";
  import "./JuryDashboard.scss";
  import {
    FormHeading,
    RedContent,
    RedMainHeading,
    StatusSubContent,
    SubGreyHeading,
  } from "../../Global/GlobalText";
  import { IoSearchSharp } from "react-icons/io5";
  import {
    CreateButton,
    GreyBackgroundButton,
    GreyfilterButton,
    RedBackgroundButton,
    RedBorderButton,
  } from "../../Global/GlobalButton";
  import { LuFilter } from "react-icons/lu";
  import { GlobalThirdTable } from "../../Global/GlobalThirdTable/GlobalThirdTable";
  import { Pie } from "react-chartjs-2";
  import { JuryTitleBar } from "../../Global/JuryTitleBar/JuryTitleBar";
  import axios from "axios";
  import { EXCHNAGE_URL, EXCHNAGE_URL_JUDGE } from "../../../Url/Url";
  import { toast } from "react-toastify";
  import { useLocation, useNavigate } from "react-router-dom";
  import { queryByRole } from "@testing-library/react";
  import { useLoading } from "../../LoadingContext";
  import LoaderDot from "../../LoaderDot";

  export const JuryDashboard = () => {

    const [juryData, setJuryData] = useState()
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0 });
    const [newToken, setNewToken] = useState("")
    const token = localStorage.getItem("token")
    const [data, setData] = useState([]);
    const navigate = useNavigate()
    const location = useLocation();
    const { setLoading } = useLoading(); 
    
  console.log("juryData",juryData)
    const [queryParams, setQueryParams] = useState({
      judgemail: "",
      eventId: "",
      roundId: ""
    });

    useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const judgemail = searchParams.get('judgemail');
      const eventId = searchParams.get('eventId');
      const roundId = searchParams.get('roundId');
  console.log("eventid",eventId,roundId)
      if (judgemail && eventId && roundId) {
        setQueryParams({ judgemail, eventId, roundId });
      } else {
        navigate('/404'); 
      }
    }, [location.search, navigate]);
    
    const [columns] = useState([
      { key: "category", label: "Submission ID" },
      { key: "status", label: "Status" },
      { key: "progress", label: "Progress" },
      { key: "actions", label: "Actions" },
    ]);

    const datatwo = {
      labels: ["Scored", "To Be Scored", "Abstained"],
      datasets: [
        {
          data: [30, 60, 10],
          backgroundColor: ["#28A745", "#DC3545", "#C4C4C4"],
          hoverBackgroundColor: ["#28A745", "#DC3545", "#C4C4C4"],
        },
      ],
    };  
    // Options for the chart
    const options = {
      plugins: {
        legend: {
          display: false, // Hide default legend
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    };


    const handleRowClick = (row) => {
      console.log("Row clicked:", row);
    };


    
    const getJuryData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${EXCHNAGE_URL_JUDGE}/fetchJudgeData?email=${queryParams.judgemail}&eventId=${queryParams.eventId}&roundId=${queryParams.roundId}`, {
          headers: {
            // "Authorization": `Beared ${token}`,
            "Content-Type": "application/json"
          }
        });
        if (response.status === 200) {
          toast.success("Data Fetched Successfully");
          const juryData = response.data;
          setJuryData(juryData);
        
          // Store token
          const tokenGet = response.data.juryToken;
          setNewToken(tokenGet);
          localStorage.setItem("juryToken", tokenGet);
          const isIndividualCategoryAssigned = response.data.data.is_individual_category_assigned;
          console.log(isIndividualCategoryAssigned)
          // Map award categories dynamically
          const mappedData = response.data.data.award_categories.map((category) => {
            const progressPercentage =
              category.totalSubmissions > 0
              ? Math.round((category.scored_submissions / category.totalSubmissions) * 100)
              : 0;
        
              const getProgressColor = (progress) => {
                if (progress === 100) return "#00ac4f"; 
                if (progress >= 50) return "#FFA500"; 
                return "#FF0000"; 
              };
 const isConfirmedForCategory = juryData.juryconfirm?.some(
    (jc) => jc.categoryId === String(category.awardId) && jc.isConfirmed === 1
  );
            return {
              category: category.categoryName,
              catId: category.awardId,
              status: (
                <span className="score_status">
                  {category.scoreStatus}
                </span>
              ),
              progress: (
                <span
          className="score_progress"
          style={{
            backgroundColor: getProgressColor(progressPercentage),
            color: "#ffffff",
            fontFamily: "Poppins",
            fontSize: "8px",
            fontWeight: "500",
            lineHeight: "20px",
            textAlign: "left",
            padding: "0px 9px",
            display: "flex",
            justifyContent: "space-between",
            borderRadius: "30px",
          }}
        >
                  <span>{progressPercentage}%</span>
          <span>
            {category.scored_submissions} of {category.totalSubmissions}
          </span>
                </span>
              ),
              actions: (
                <div style={{ display: "flex", gap: "10px", justifyContent:"center" }}>
                <RedBackgroundButton
                  type="button"
                  style={{ fontSize: "13px" }}
                            disabled={isConfirmedForCategory}

                  onClick={() => {
                    const queryString = new URLSearchParams(queryParams).toString();
                    navigate(`/jury-entry-listing?${queryString}`, {
                      state: {
                        logoImg: response.data.dashdata.event_logo,
                        eventName: response.data.dashdata.event_name,
                        fName: response.data.judgefirst,
                        lName: response.data.judgelastname,
                        awardCat: response.data.data.award_categories,
                        eventIdd: response.data.dashdata.id,
                        judgeId: response.data.judgeid,
                        queryParams: { ...queryParams },
                        juryData: juryData,
                        awardCatId: category.awardId,
                      },
                    });
                  }}
                >
                  Score
                </RedBackgroundButton>
        {isIndividualCategoryAssigned === 1 && category.scoreStatus === "scored" && (
    <GreyBackgroundButton
      type="button"
      onClick={() => confirmScoring(category.awardId)}
    >
      Confirm
    </GreyBackgroundButton>
  )}


              </div>
              ),
            };
          });
        
          setData(mappedData);
        }
        
      } catch (error) {
        setLoading(false);
      
        if (error.response && error.response.data) {
          const serverMessage = error.response.data.message;
      
          if (serverMessage === "You are locked by admin.") {
            toast.error("Access Denied: You are locked by the admin.");
            // Optional: Redirect or show a special UI
            return;
          }
      
          toast.error(serverMessage || "Error While Fetching Data");
        } else {
          toast.error("Unexpected error occurred");
        }
      
        console.log("Error fetching jury data:", error);
      }finally {
        setLoading(false);
      }
    }

    useEffect(() => {
      if (queryParams.judgemail && queryParams.eventId && queryParams.roundId) {
        getJuryData();
      }
    }, [queryParams]);

    const formatDate = (isoString) => {
      const date = new Date(isoString);
      return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
      }).replace(/ /g, '-');
  };
  const currentDate = formatDate(new Date())


  const endDate = formatDate( juryData && juryData.dashdata.end_date)
  useEffect(() => {
    const calculateTimeLeft = () => {
        const currentDate = new Date();
        const targetDate = new Date(endDate);

        const targetUTC = Date.UTC(
            targetDate.getFullYear(),
            targetDate.getMonth(),
            targetDate.getDate(),
            23, 59, 59, 999 
        );

        const currentUTC = Date.now(); 

        const diffInTime = targetUTC - currentUTC;

        if (diffInTime > 0) {
            const days = Math.floor(diffInTime / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diffInTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            setTimeLeft({ days, hours });
        } else {
            setTimeLeft({ days: 0, hours: 0 });
        }
    };

    calculateTimeLeft();

    const interval = setInterval(calculateTimeLeft, 1000 * 60 * 60);
    return () => clearInterval(interval);
  }, [endDate]);


  const formatTime = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }) + " (GMT+04:00)";
  };

  const isRoundInactive = juryData?.dashdata?.active_round !== 1 || (endDate && new Date() > new Date(juryData.dashdata.end_date));
  const confirmScoring = async (awardId) => {
    try {
      setLoading(true);
      const payload = {
        eventId: parseInt(queryParams.eventId),
        roundId: parseInt(queryParams.roundId),
        categoryId: awardId,
        judge_email: queryParams.judgemail
      };

      const response = await axios.post(`${EXCHNAGE_URL_JUDGE}/confirm-score`, payload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${newToken || localStorage.getItem("juryToken")}`
        }
      });

      if (response.status === 200) {
        toast.success("Scoring Confirmed Successfully");
        getJuryData(); // refresh data
      } else {
        toast.error("Failed to confirm scoring");
      }
    } catch (error) {
      console.error("Error confirming score:", error);
      toast.error(error.response?.data?.message || "Error confirming score");
    } finally {
      setLoading(false);
    }
  };


console.log(juryData,"juryData")
  return (
    <>
    
  : {juryData ? (
    juryData?.dashdata?.active_round !== 1 || (endDate && new Date() > new Date(juryData.dashdata.end_date)) ? ( 
        <div className="inactive_round" style={{ textAlign: "center" }}>
          <RedMainHeading
            style={{ textAlign: "center", marginTop: "1rem", marginBottom: "1rem" }}
          >
            Round is Inactive
          </RedMainHeading>
          <StatusSubContent>
            The jury round is currently inactive. Please try again later.
          </StatusSubContent>
        </div>
      ) : ( 
        <div>
          <div className="jurydashboard_div">
            <JuryTitleBar
              logoImg={juryData.dashdata.event_logo}
              eventName={juryData.dashdata.event_name}
              fName={juryData.judgefirst}
              lName={juryData.judgelastname}
              messageHtml={juryData.dashdata.jury_welcm_messsage}
            />
            <div className="jurydashboard_white_bg">
              <div className="jurydashboard_head">
                <RedMainHeading className="titlbar_head">
                  Judging - Dashboard
                </RedMainHeading>
              </div>

              <div className="jurydashboard_judging_main">
                <div className="jurydashboard_judging_submain">
                  <SubGreyHeading>
                    Hi {`${juryData.judgefirst} ${juryData.judgelastname}`},
                  </SubGreyHeading>
                  <StatusSubContent>
                    Welcome to the Jury round of{" "}
                    <span style={{ fontWeight: 600 }}>
                      {juryData?.dashdata?.event_name}!{" "}
                    </span>
                    We greatly appreciate your time and expertise in evaluating
                    our participants' work. Your insights are invaluable, and we
                    look forward to your assessments.
                  </StatusSubContent>
                </div>

                <div className="jurydashboard_judging_submain">
                  <div>
                    <CreateButton>Submissions</CreateButton>
                  </div>

                  <div className="jurydashboard_score_chart">
                    <div className="jurydashboard_sub_score_chart">
                      <div className="jurydashboard_score_pointer">
                        <span className="green_pointer"></span>
                        <SubGreyHeading>Scored </SubGreyHeading>
                      </div>

                      <div className="jurydashboard_score_pointer">
                        <span className="red_pointer"></span>
                        <SubGreyHeading>Scored </SubGreyHeading>
                      </div>

                      <div className="jurydashboard_score_pointer">
                        <span className="grey_pointer"></span>
                        <SubGreyHeading>Scored </SubGreyHeading>
                      </div>
                    </div>

                    <div className="jurydashboard_sub_score_chart">
                      <Pie data={datatwo} options={options} />
                    </div>
                  </div>
                </div>

                <div className="jurydashboard_judging_submain">
                  <div className="jurydashboard_end_head">
                    <SubGreyHeading>Ends On</SubGreyHeading>
                    <div className="jurydashboard_end_sub_head">
                      <FormHeading>{endDate}</FormHeading>
                      <RedContent>
                        {`${timeLeft.days} Days ${timeLeft.hours} Hours Left`}{" "}
                      </RedContent>
                    </div>
                  </div>

                  <div className="jurydashboard_end_head">
                    <SubGreyHeading>Ends At</SubGreyHeading>
                    <div className="jurydashboard_end_sub_head">
                      <FormHeading>
                        {formatTime(juryData?.dashdata.end_time || "22:33")}
                      </FormHeading>
                    </div>
                  </div>
                </div>
              </div>

              <div className="jurydashboard_table_div">
                <RedMainHeading className="titlbar_head">
                  Categories Assigned (1)
                </RedMainHeading>

                <div className="jurydashboard_btn">
                  {juryData?.data?.is_Completed_Submission === 1 && (
                    <RedBorderButton>Confirm Entry Scores</RedBorderButton>
                  )}

                  <div className="jurydashboard_search">
                    <div className="jurydashboard_icon">
                      <IoSearchSharp />
                    </div>
                    <div className="jurydashboard_content">
                      <input type="text" placeholder="Search here..." />
                    </div>
                  </div>
                </div>
              </div>

              <GlobalThirdTable
                data={data}
                columns={columns}
                onRowClick={handleRowClick}
              />
            </div>
          </div>
        </div>
      )
    ) : (
      <div><LoaderDot/></div>
    )}
  </>
  );
  }